import { environment } from "@environment";

export const shouldDisableTrack = (email: string) => {
  return email.includes("@storydoc.com") && environment.env === "production";
};
